{"scale":{"title":{"ios":22,"mac":17},"figure":{"ios":20,"mac":15},"body":{"ios":17,"mac":13},"secondary":{"ios":15,"mac":12},"detail":{"ios":13,"mac":11}}}
